import { useFeatureFlags } from './useFeatureFlags';

export const useEnhancedLipsyncEnabled = (): boolean => {
  const { featureEnabled: isLipsyncEnabled } = useFeatureFlags('lipsync');
  const { featureEnabled: isLipsyncV2Enabled } = useFeatureFlags('lipsync_v2');

  return isLipsyncEnabled && isLipsyncV2Enabled;
};
